import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import BlueCheckbox from 'components/atoms/BlueCheckbox'

const styles = theme => ({
  root: {
    height: 52,
    borderBottom: `1px solid ${theme.palette.background.medium}75`,
  },
  label: {
    fontSize: 14,
  },
})

class RowWithCheckbox extends PureComponent {
  onCheckboxClick = () => {
    const { onSelect, data } = this.props
    onSelect(data)
  };

  render() {
    const { classes, title, selected } = this.props

    return (
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.root}>
        <Typography className={classes.label}>{title}</Typography>
        <BlueCheckbox onChange={this.onCheckboxClick} checked={selected} />
      </Grid>
    )
  }
}

RowWithCheckbox.propTypes = {
  data: PropTypes.any,
  title: PropTypes.string,
  onSelect: PropTypes.func,
  selected: PropTypes.bool,
  classes: PropTypes.object,
}

export default withStyles(styles)(RowWithCheckbox)



// WEBPACK FOOTER //
// ./src/components/molecules/RowWithCheckbox.js